import React from "react";
import "./about.css";
import ab from "../../../images/medical-team-yitalife-kampala.jpeg";
import abFallback from "../../../images/11.jpg";
import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="about-section" aria-labelledby="about-heading">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Left: Text */}
          <div className="col-lg-4 col-md-12" data-aos="fade-right">
            <div className="about-label-tag">
              <ion-icon name="shield-checkmark-outline"></ion-icon>
              Who We Are
            </div>
            <h2 className="about-org-name" id="about-heading">
              Yitalife
            </h2>
            <p className="about-yms-inline">
              <em>A service of Yita Medical Services (YMS)</em>
            </p>
            <p className="about-description">
              Yita Medical Services (YMS) is a registered enterprise (Reg No.
              80020035497111) providing equitable access to affordable,
              high-quality, doctor-led healthcare with special attention to
              remote communities. We use part of our income to support
              humanitarian work under TEC-Uganda and other causes.
            </p>
            <Link to="/AboutUs">
              <button className="about-read-more">
                Read Our Story
                <ion-icon name="arrow-forward-outline"></ion-icon>
              </button>
            </Link>
          </div>

          {/* Middle: Image */}
          <div
            className="col-lg-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div className="about-img-wrapper">
              <img
                src={ab}
                alt="Yitalife medical team - Yita Medical Services, home healthcare Uganda"
                onError={(e) => {
                  e.target.src = abFallback;
                }}
              />
              <div className="about-img-badge">
                <div className="about-img-badge-icon">
                  <ion-icon name="ribbon-outline"></ion-icon>
                </div>
                <div className="about-img-badge-text">
                  <strong>Est. 2019</strong>
                  <span>Active since 2020</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Hours + Help */}
          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-left"
            data-aos-delay="150"
          >
            {/* Opening Hours */}
            <div className="hours-card">
              <div className="hours-card-header">
                <ion-icon name="alarm-outline"></ion-icon>
                Booking Hours
              </div>
              <ul className="hours-list">
                <li>
                  <span className="hours-day">Monday - Friday</span>
                  <span className="hours-time">8:30 am - 7:00 pm</span>
                </li>
                <li>
                  <span className="hours-day">Saturday</span>
                  <span className="hours-time">10:00 am - 7:00 pm</span>
                </li>
                <li>
                  <span className="hours-day">Sunday</span>
                  <span className="hours-time">10:00 am - 7:00 pm</span>
                </li>
              </ul>
            </div>

            {/* Need Help */}
            <div className="help-card">
              <div className="help-card-title">Need Help? Reach Us Here</div>
              <div className="help-social">
                <a
                  href="https://x.com/yitalife"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Twitter"
                >
                  <ion-icon name="logo-twitter"></ion-icon>
                </a>
                <a
                  href="https://www.facebook.com/yitalife.yms?mibextid=LQQJ4d"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <ion-icon name="logo-facebook"></ion-icon>
                </a>
                <a href="mailto:info@yitalife.com" aria-label="Email">
                  <ion-icon name="mail-outline"></ion-icon>
                </a>
                <a href="tel:+256777114327" aria-label="Phone">
                  <ion-icon name="call-outline"></ion-icon>
                </a>
              </div>
              <Link to="/Contact">
                <button className="help-contact-btn">Contact Us Today</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
